<template>
  <zm-drawer
    ref="zmDrawer"
    :visible="visible"
    :title="title"
    :footer="footer"
    :okText="okText"
    :width="'75%'"
    :placement="placement"
    @cancel="cancel"
    @ok="submitForm"
    class="modal"
  >
    <div slot="drawerBody">
      <a-form-model
        ref="dataForm"
        :model="dataForm"
        v-bind="formItemLayoutWithOutLabel"
      >
        <a-row>
          <a-col :span="8">
            <span class="tabsName" :style="{color: dropdownLinkName === item.label ? '#08409F' : '#BFBFBFFF'}" v-for="item in derivationModeList" @click="changeExportType(item)"> {{ item.label }}</span>
            <!--            <a-dropdown placement="bottomCenter">-->
            <!--              <a class="ant-dropdown-link">-->
            <!--                <img src="@/assets/icon_switch.png" alt="" style="margin-bottom: 2px;">-->
            <!--              </a>-->
            <!--              <a-menu slot="overlay">-->
            <!--                <a-menu-item v-for="item in derivationModeList">-->
            <!--                  <a href="javascript:;" @click="changeExportType(item)">{{ item.label }}</a>-->
            <!--                </a-menu-item>-->
            <!--              </a-menu>-->
            <!--            </a-dropdown>-->
          </a-col>
        </a-row>
        <div v-if="!customFieldShow" style="margin-top: 10px;">
          <module-box></module-box>
        </div>
        <div v-if="customFieldShow">
          <a-row
            class="marginTop_10"
            :style="{borderBottom: (fixedModule.length-1 !== index) ? '1px dashed #d9d9d9' : 'none'}"
            v-for="(domain, index) in fixedModule"
            :key="domain.key">
            <a-col :span="8">
              <a-form-model-item
                class="marginBtm_0"
                v-bind="formItemLayout"
                label="分类模块"
              >
                <span>{{ domain.icon }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" style="margin-bottom: 10px;">
              <div class="checkBoxGroupDiv">
                <a-checkbox class="allCheckBox checkBoxGroupTitle" :indeterminate="domain.indeterminate" :checked="domain.checkAll" @change="fixedAllChange(index, $event)">
                  全选
                </a-checkbox>
                <a-checkbox-group class="checkBoxGroup" v-model="domain.chickList" :options="domain.items" @change="fixedOnChange(index, $event)"/>
              </div>
            </a-col>
          </a-row>
        </div>
      </a-form-model>
    </div>
  </zm-drawer>
</template>

<script>
import exportWrap from './exportWrap.json'
import { getAssetExport } from '@/api/assetLedger'
import ModuleBox from '@/views/assetLedger/modules/moduleBox'
import moment from 'moment'
export default {
  components: { ModuleBox },
  data () {
    return {
      // 抽屉是否显示
      visible: false,
      // 抽屉标题
      title: '',
      footer: true,
      okText: '导出',
      placement: 'right',
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 }
      },
      formItemLayoutWithOutLabel: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 }
      },
      btnLoading: false,
      dataForm: {
        exportType: '2',
        moduleList: []
      },
      dropdownLinkName: '自定义导出',
      // 导出方式列表下拉
      derivationModeList: [
        {
          value: '2',
          label: '自定义导出'
        },
        {
          value: '1',
          label: '资产盘点模板'
        }
      ],
      // 自定义字段显示
      customFieldShow: true,
      fixedModule: exportWrap,
      searchModel: {}
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.searchModel = model
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.visible = flag
    },
    // 导出
    submitForm () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          this.$refs.zmDrawer.handleOkLoading(true)
          const params = {
            exportType: this.dataForm.exportType,
            ...this.searchModel
          }
          if (this.dataForm.exportType === '2') {
            params.colKeys = []
            params.headNames = []
            this.fixedModule.map(item => {
              item.chickList.forEach(item2 => {
                const arr = item2.split(';')
                params.colKeys.push(arr[1])
                params.headNames.push(arr[0])
              })
            })
          }
          if (params.historyMonth) {
            params.year = Number(moment(params.historyMonth).format('YYYY'))
            params.month = moment(params.historyMonth).format('MM')
          }
          getAssetExport(params).then(res => {
            var blob = new Blob([res])
            var downloadElement = document.createElement('a')
            var href = window.URL.createObjectURL(blob)
            downloadElement.href = href
            downloadElement.download = '资产列表.xls'
            document.body.appendChild(downloadElement)
            downloadElement.click()
            document.body.removeChild(downloadElement)
            window.URL.revokeObjectURL(href)
            this.cancel()
            this.$refs.zmDrawer.handleOkLoading(false)
          })
            .catch(err => {
              this.$refs.zmDrawer.handleOkLoading(false)
            })
        } else {
          return false
        }
      })
    },
    // 改变导出方式
    changeExportType (item) {
      this.dropdownLinkName = item.label
      this.dataForm.exportType = item.value
      if (item.value === '1') {
        this.customFieldShow = false
      } else {
        this.customFieldShow = true
      }
    },
    // 固定模块字段选中
    fixedOnChange (index, checkedList) {
      this.fixedModule[index].indeterminate = !!checkedList.length && checkedList.length < this.fixedModule[index].items.length
      this.fixedModule[index].checkAll = checkedList.length === this.fixedModule[index].items.length
      this.$forceUpdate()
    },
    // 固定模块字段全选
    fixedAllChange (index, e) {
      const plainOptions = []
      this.fixedModule[index].items.forEach(item => {
        plainOptions.push(item.value)
      })
      this.fixedModule[index].chickList = e.target.checked ? plainOptions : []
      this.fixedModule[index].checkAll = e.target.checked
      this.fixedModule[index].indeterminate = false
      this.$forceUpdate()
    },
    // 关闭抽屉
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 重置
    formClear () {
      this.$nextTick(() => {
        this.fixedModule.forEach(item => {
          item.chickList = []
          item.checkAll = false
          item.indeterminate = false
        })
        this.dataForm = {
          exportType: '2',
          moduleList: []
        }
        this.dropdownLinkName = '自定义导出'
        this.customFieldShow = true
        this.btnLoading = false
        this.searchModel = {}
      })
    }
  }
}
</script>
<style lang="less">
.closeIcon {
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .moduleColseImg {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}
.allCheckBox {
  //margin-bottom: 15px;
}
.checkBoxGroupDiv {
  display: flex;
  .checkBoxGroupTitle {
    width: 60px;
  }
  .checkBoxGroup {
    width: calc(100% - 35px);
    >.ant-checkbox-group-item {
      margin-bottom: 14px;
    }
  }
}
.marginTop_10 {
  margin-top: 10px;
}
.marginBtm_0 {
  margin-bottom: 0;
}
.add-btn {
  margin-top: 20px;
}
.export_btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
  .cancel {
    margin-left: 20px;
  }
}
.ant-select-dropdown{
  .ant-select-dropdown-content {
    .ant-select-dropdown-menu {
      .ant-select-dropdown-menu-item-disabled {
        color: rgba(0, 0, 0, 0.25) !important;
      }
    }
  }
}
.tabsName {
  font-size: 14px;
  font-weight: bold;
  margin-right: 13px;
  cursor: pointer;
}
</style>
